<template>
  <div class="products-category">
    <h2 v-if="this.$route.params.cate == 'foam_ear_plugs'">Foam Ear Plugs</h2>
    <h2 v-if="this.$route.params.cate == 'silicone_ear_plugs'">Silicone Ear Plugs</h2>
    <h2 v-if="this.$route.params.cate == 'filter_ear_plugs'">Filter Ear Plugs</h2>
    <h2 v-if="this.$route.params.cate == 'moldable_ear_plugs'">Custom Moldable Ear Plugs</h2>
    <h2
      v-if="this.$route.params.cate == 'passive_noise_reduction_ear_muffs'"
    >Passive Noise Reduction Ear Muffs</h2>
    <h2 v-if="this.$route.params.cate == 'baby_ear_muffs'">Baby Ear Muffs</h2>
    <h2 v-if="this.$route.params.cate == 'electronic_ear_muffs'">Shooting Ear Muffs</h2>
    <!-- {{ proCat.dataSet }} -->
    <a-row :gutter="32" type="flex">
      <a-col v-for="product in proCat.dataSet" :md="{ span: 6 }" :xs="{ span: 24 }">
        <router-link :to="'/category/' + $route.params.cate + '/' + product.slug">
          <a-card hoverable>
            <img :alt="product.title" :src="thumbUrl(product.text)" slot="cover" />
            <a-card-meta :title="product.title">
              <template slot="description">
                <!-- <span v-for="spec in product.fields">
                  {{ spec.name }}: {{ spec.value }}
                </span>-->
                <span
                  v-if="product.fields.SNR"
                >{{ product.fields.SNR.name }} : {{ product.fields.SNR.value }}</span>
                <span
                  v-if="product.fields.NRR"
                >{{ product.fields.NRR.name }} : {{ product.fields.NRR.value }}</span>
              </template>
            </a-card-meta>
          </a-card>
        </router-link>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// import axios from "axios";

export default {
  name: "ProductsCategory",
  data() {
    return {
      proCat: "",
      proCatName: ""
    };
  },
  metaInfo() {
    return {
      title: this.proCatName,
      titleTemplate: null
    };
  },
  methods: {
    getProCat() {
      let queryLink =
        "https://rest.cnsian.com/api/posts?filterType=category&showContent=true&pageSize=100&filterSlug=" +
        this.$route.params.cate;
      fetch(queryLink)
        .then(res => res.json())
        .then(data => {
          this.proCat = data.data;
          this.proCatName = this.$route.params.cate;
        });
      // axios
      //   .get(queryLink)
      //   .then(res => {
      //     this.proCat = res.data.data
      //     this.proCatName = this.$route.params.cate
      //   });
    },
    thumbUrl(str) {
      let url;
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, function(match, capture) {
        url = capture;
      });
      if (!url) {
        return "https://img.cnsian.com/images/2b300bacca6cbcac50ac00faa17154eb.jpg";
      } else {
        return url;
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.getProCat();
      }
    }
  }
};
</script>

<style lang="scss">
.products-category {
  padding: 3em 12.5%;
  .ant-card {
    margin-bottom: 3em;
    overflow: hidden;
    img {
      // transition: all 0.5s ease;
      transition: all 0.5s ease-in-out;
      &:hover {
        transform: scale(1.1);
      }
    }
    .ant-card-meta-title {
      white-space: normal;
      overflow: visible;
      font-size: 24px;
    }
    .ant-card-meta-description {
      font-size: 17px;
      span {
        margin: 2px 6px;
        padding: 0 6px;
        border: 1px solid rgba(0, 0, 0, 0.09);
        border-radius: 0.3em;
      }
    }
  }
}
</style>
